module.exports = __webpack_public_path__ + "img/doc.a5cceae1.svg";